// extracted by css-extract-rspack-plugin
export default {"info-card-label":"InfoCardLabel_info-card-label__+NIN5"};